
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    display: block
}

.cta-collection__card-wrapper {

    display: flex
}

.cta-collection__card-wrapper {

    flex-grow: 1
}

.cta-collection__card-wrapper {

    flex-direction: column
}

.cta-collection__card-wrapper {

    border-radius: 0.75rem
}

.cta-collection__card-wrapper {

    background-color: var(--primary-blue)
}

.cta-collection__card-wrapper {

    padding: 1.5rem
}

.cta-collection__card-wrapper {

    color: var(--neutral-white)
}

.cta-collection__content {

    display: flex
}

.cta-collection__content {

    flex-direction: column
}

.cta-collection__content {

    gap: 2rem
}

@media (min-width: 768px) {

    .cta-collection__content {

        flex-direction: row
    }
}

@media (min-width: 768px) {

    .cta-collection__content {

        gap: 2.5rem
    }
}

@media (min-width: 768px) {

    .cta-collection__content {

        padding: 1rem
    }
}

.cta-collection__v-separator {

    border-right-width: 0px
}

.cta-collection__v-separator {

    border-top-width: 1px
}

.cta-collection__v-separator {

    border-bottom-width: 0px
}

.cta-collection__v-separator {

    border-style: solid
}

.cta-collection__v-separator {

    border-color: var(--primary-blue-light-2)
}

@media (min-width: 768px) {

    .cta-collection__v-separator {

        width: 1px
    }
}

@media (min-width: 768px) {

    .cta-collection__v-separator {

        border-left-width: 1px
    }
}

@media (min-width: 768px) {

    .cta-collection__v-separator {

        border-top-width: 0px
    }
}

ghs-heading {

    flex-shrink: 0;

    color: var(--neutral-white)
}

@media (min-width: 768px) {

    ghs-heading {

        width: 33.333333%
    }
}

::slotted([slot='content']) {

    display: flex;

    flex-wrap: wrap;

    align-items: center;

    gap: 1.5rem
}

@media (min-width: 768px) {

    ::slotted([slot='content']) {

        gap: 2rem
    }
}

:host([site='BH']) .cta-collection__card-wrapper {

    background-color: var(--bh-brand-primary-default)
}

:host([site='BH']) .cta-collection__card-wrapper {

    padding: 1rem
}

:host([site='BH']) .cta-collection__card-wrapper {

    color: var(--bh-neutral-white)
}

:host([site='BH']) .cta-collection__content {

    border-radius: 0.5rem
}

:host([site='BH']) .cta-collection__content {

    border-width: 1px
}

:host([site='BH']) .cta-collection__content {

    border-style: solid
}

:host([site='BH']) .cta-collection__content {

    border-color: var(--bh-brand-primary-lighter)
}

:host([site='BH']) .cta-collection__content {

    padding: 1rem
}

@media (min-width: 1024px) {

    :host([site='BH']) .cta-collection__content {

        padding-top: 1.5rem;

        padding-bottom: 1.5rem
    }
}

@media (min-width: 1024px) {

    :host([site='BH']) .cta-collection__content {

        padding-left: 2rem;

        padding-right: 2rem
    }
}

:host([site='BH']) .cta-collection__v-separator {

    display: none
}

:host([site='BH']) ghs-heading {

    color: var(--bh-neutral-white)
}
`;